
<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.legend-con {
  font-family: "Prompt", sans-serif !important;
  display: inline-block;

  ul {
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    span {
      display: inline-block;
    }

    span.chart-legend {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
}
</style>


<template>
  <v-container fluid>
    <div
      class="text-h4 font-weight-black primary--text text-spacing"
      color="blue"
    >
      รายงานภาพรวม
    </div>
    <v-divider class="my-2"></v-divider>
    <v-row>
      <v-col cols="12" lg="6">
        <v-card elevation="5">
          <v-container>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black primary--text mt-n5"
                  >
                    <v-row class="ma-0">
                      <v-col cols="12" lg="3" class>ยอดขายตามสินค้า</v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mb-6">
                  <router-link to="/DrillDown">ดูเพิ่มเติม >>></router-link>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider class="mb-4 mt-n5"></v-divider>
            <v-col cols="12" lg="4" class="my-n4 ml-4">
              <v-select label="เลือกช่วงเวลา" dense outlined></v-select>
            </v-col>
            <Doughnut
              :styles="myStyles"
              :dataLabels="lb3"
              :dataSet="d3"
            ></Doughnut>
            <div id="my-legend-con" class="legend-con"></div>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <v-card elevation="5">
          <v-container>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black primary--text mt-n5"
                  >
                    <v-row class="ma-0">
                      <v-col cols="12" lg="3" class>รายได้ทั้งหมด</v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="mb-6">
                  <router-link to="/DrillDown">ดูเพิ่มเติม >>></router-link>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider class="mb-4 mt-n5"></v-divider>
            <v-col cols="12" lg="4" class="my-n4 ml-4">
              <v-select label="เลือกช่วงเวลา" dense outlined></v-select>
            </v-col>
            <LineChart
              :styles="barStyle"
              :Labels="line_lable1"
              :DataSet="line_data1"
            ></LineChart>
          </v-container>
        </v-card>
      </v-col>
<!--
      <v-col cols="12" lg="7">
        <v-card elevation="5">
          <v-container>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black primary--text mt-n5"
                  >
                    <v-row class="ma-0">
                      <v-col cols="12" lg="6" class>
                        ตารางการโอนถ่ายขยะวันที่
                        <date-picker
                          color="black"
                          class="mb-1 custom-datepicker"
                          style="width: 100%"
                          :format="momentFormat"
                          v-model="now_Date"
                        ></date-picker>
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>

                <v-btn
                  class="my-5"
                  color="primary"
                  elevation="0"
                  dark
                  link
                  @click="searchCollect_Removal()"
                >
                  <v-icon left>mdi-cloud-search</v-icon>ค้นหา
                </v-btn>
                <v-btn
                  class="my-5 mx-2"
                  color="primary"
                  elevation="0"
                  dark
                  link
                  @click="Transfer_Detail()"
                >
                  <v-icon left>mdi-cloud-search</v-icon>ดูรายละเอียด
                </v-btn>
              </v-list-item>
            </v-list>
            <v-divider class="mb-4 mt-n5"></v-divider>
            <comTransferWasteAll />
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5">
        <v-card elevation="5">
          <v-container>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-black primary--text mt-n5"
                  >
                    <v-row class="ma-0">
                      <v-col cols="12" lg="3" class>
                        สรุปยอดเผาเก็บขนและกำจัดประจำเดือน
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>

                <v-btn
                  class="my-5"
                  color="primary"
                  elevation="0"
                  dark
                  link
                  @click="searchCollect_Removal()"
                >
                  <v-icon left>mdi-cloud-search</v-icon>ค้นหา
                </v-btn>
              </v-list-item>
            </v-list>
            <v-divider class="mb-4 mt-n5"></v-divider>
            <v-col cols="12" lg="12">
              <v-row justify="space-around">
                <v-date-picker
                  v-model="picker"
                  type="month"
                  locale="th"
                  color="green lighten-1"
                  header-color="primary"
                ></v-date-picker>
              </v-row>
            </v-col>
          </v-container>
        </v-card>
      </v-col>
      -->
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import LineChart from "../../components/LineChart";
import BarChart from "../../components/BarChart";
import Doughnut from "../../components/DoughnutChart";
import comTransferWasteAll from "../../components/_tableReport/comTransfer_WasteAll";
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    LineChart,
    Doughnut,
    BarChart,
    comTransferWasteAll,
  },
  name: "Dashboard",
  data: () => ({
    line_lable1: [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค​.",
    ],
    line_data1: [
      {
        label: "รายได้ (บาท)",
        data: [
          35835,
          171216,
          733882,
          631247,
          744267,
          618973,
          357024,
          164773,
          526055,
          355581,
          541957,
          445791,
        ],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
      },
    ],
    lb3: [
      "ค่าบริการเหมาจ่าย",
      "ขยะมูลฝอยติดเชื้อ",
      "ค่าบริการกำจัดมูลฝอยติดเชื้อ",
      "ค่าเก็บขยะรายเดือน",
      "อื่นๆ",
    ],
    d3: [
      {
        backgroundColor: [
          "#82B1FF",
          "#448AFF",
          "#2979FF",
          "#2962FF",
          "#CFD8DC",
        ],
        data: [20, 5, 15, 60, 30],
      },
    ],
    height: 260,
    picker: new Date().toISOString().substr(0, 7),
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    now_Date: new Date(),
  }),
  watch: {},
  computed: {
    barStyle() {
      return {
        height: `284px`,
        position: "relative",
      };
    },
    myStyles() {
      return {
        height: `${this.height}px`,
        position: "relative",
      };
    },
  },
  methods: {
    ...mapMutations({
      SET_ALL: "SummaryCollectRemoval/SET_ELEMENT",
    }),
    searchCollect_Removal() {
      //console.log(this.picker);
      this.SET_ALL({ key: "Y_M", value: this.picker });
      this.$router.push({ path: "/SummaryMonth" });
    },
    Transfer_Detail() {
      this.$router.push({ path: "/Transfer-Waste" });
    },
  },
  mounted() {},
};
</script>


